// @ngInject
function SupportApiService(ResourcesService, DSHttpAdapter, $q, DS) {

    var endpoint = 'support';

    return {
        changeItemGroup: ResourcesService.apiFactory.update(endpoint + '/changeitemgroup'),
        changeBarcode: ResourcesService.apiFactory.update(endpoint + '/changebarcode'),
        changeBarcodes: ResourcesService.apiFactory.update(endpoint + '/changebarcodes'),
        createLocation: ResourcesService.apiFactory.create(endpoint + '/createlocation'),
        deleteProduct: ResourcesService.apiFactory.delete(endpoint + '/deleteproduct'),
        mergeProducts: ResourcesService.apiFactory.update(endpoint + '/mergeproducts'),
        getItemGroupBriefs: ResourcesService.apiFactory.get(endpoint + '/itemgroups'),
        getLocationTypes: ResourcesService.apiFactory.get(endpoint + '/locationtypes'),
        getLocationCategories: ResourcesService.apiFactory.get(endpoint + '/locationcategories'),
        getProductBriefs: ResourcesService.apiFactory.get(endpoint + '/products'),
        getProduct: ResourcesService.apiFactory.get(endpoint + '/product'),
        changeIsGroupSaleArticle: ResourcesService.apiFactory.update(endpoint + '/changeisgroupsalearticle'),
        addVariantDetail: ResourcesService.apiFactory.create(endpoint + '/addvariantdetail'),
        addVariantDetails: ResourcesService.apiFactory.create(endpoint + '/addvariantdetails'),
        updateInventoryStatus: ResourcesService.apiFactory.update(endpoint + '/updateinventorystatus'),
        getLocations: ResourcesService.apiFactory.get(endpoint + '/locations'),
        createOriginalBalance: ResourcesService.apiFactory.create(endpoint + '/originalbalance'),
        getMissingEasyPosReceipts: getMissingEasyPosReceipts,
        triggerToChangeLog: triggerToChangeLog
    };

    function getMissingEasyPosReceipts(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/missingreceipts/easypos', request).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function triggerToChangeLog(request, type) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/triggertochangelog/' + type, request).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('support.api', [])
    .factory('SupportApiService', SupportApiService);
